import React from 'react';

import { ApiVona } from '@vona/shared';
import { GetCurrentVonasResponseZod } from '@vona/shared/GetCurrentVonas';

import { useApi } from '../context/ApiProvider';

type UseCurrentVonasResult = {
  error?: Error;
  loading: boolean;
  vonas: ApiVona[];
};

export const useCurrentVonas = (): UseCurrentVonasResult => {
  const [error, setError] = React.useState<Error>();
  const [loading, setLoading] = React.useState(true);
  const [vonas, setVonas] = React.useState<ApiVona[]>([]);
  const api = useApi();

  const getVonas = React.useCallback(async () => {
    try {
      const response = await api.get('/vonas');
      const parsed = GetCurrentVonasResponseZod.parse(response.data);
      setVonas(parsed.vonas);
    } catch (e) {
      setError(new Error(`Failed to fetch VONAs: ${e}`));
    } finally {
      setLoading(false);
    }
  }, [api, setVonas]);

  React.useEffect(() => {
    getVonas();
  }, [getVonas]);

  return {
    error,
    loading,
    vonas,
  };
};
